import React from 'react';
import { Chip } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

type DeltaChipProps = {
  value: number; // percent change, positive or negative
  goodWhenHigher?: boolean; // if false, lower is better (e.g., latency)
};

export const DeltaChip: React.FC<DeltaChipProps> = ({ value, goodWhenHigher = true }) => {
  const theme = useTheme();
  const isUp = value >= 0;
  const good = goodWhenHigher ? isUp : !isUp;

  const color = good ? theme.palette.success.main : theme.palette.error.main;
  const bg = alpha(color, 0.12);
  const icon = isUp ? <ArrowUpwardIcon sx={{ fontSize: 14 }} /> : <ArrowDownwardIcon sx={{ fontSize: 14 }} />;

  const formatted = `${isUp ? '+' : ''}${Math.round(value)}%`;

  return (
    <Chip
      size="small"
      icon={icon}
      label={formatted}
      sx={{
        height: 24,
        '& .MuiChip-label': { px: 0.75, fontWeight: 600 },
        backgroundColor: bg,
        borderColor: color,
        borderStyle: 'solid',
        borderWidth: 1,
        color,
      }}
      variant="outlined"
    />
  );
};

export default DeltaChip;

